import { BoxOwner } from "../../../../dtos/box";

export function filterBoxOwners(
    owners: BoxOwner[],
    searchText: string,
) {
    const lowerSearch = searchText.toLowerCase();

    return owners.filter(owner => {
        return (
            owner.fullName.toLowerCase().includes(lowerSearch) ||
            owner.firstName.toLowerCase().includes(lowerSearch) ||
            owner.lastName.toLowerCase().includes(lowerSearch) ||
            (owner.phone || "").toLowerCase().includes(lowerSearch) ||
            owner.email.toLowerCase().includes(lowerSearch) ||
            owner.address.toLowerCase().includes(lowerSearch)
        );
    });
}
